export type BOMSearch = {
    AlertDay: DayOfWeek;
    AlertFrequency: BOMAlertFrequencyType;
    Alerts: BOMSearchAlert[];
    BatchSize: number;
    BOMPermissionLevel: BOMPermissionLevel;
    CurrentUser: string;
    Distributors: BOMSearchDistributor[];
    EnableLinkSharing: boolean;
    ExportFields: string[];
    HashId: string;
    IsLocked: boolean;
    Name: string;
    OwnerName: string;
    PartCount: number;
    PartExists: boolean;
    Parts: BOMSearchPart[];
    PartSelectionCount: number;
    PossibleExportFields: string[];
    SharedUsers: BOMSearchUser[];
    ShareLink: string;
    SortOrder: BOMSortOrder;
    StockFilter: BOMStockFilter;
    TimeStamp: Date;
    UserId: number;
};

export type BOMSearchAlert = {
    Id: number;
    BOMSearchId: number;
    BOMAlertTypeId: BOMAlertTypes;
};

export enum BOMPermissionLevel {
    Public = 0,
    Viewer = 1,
    Editor = 2,
    Owner = 3,
    Sample = 4,
}

export enum BOMSortOrder {
    Default = 0,
    PartNum_Asc = 1,
    PartNum_Desc = 2,
    Manufacturer_Asc = 3,
    Manufacturer_Desc = 4,
    KgCO2e_Asc = 5,
    KgCO2e_Desc = 6,
}

enum BOMStockFilter {
    All,
    Hide_InStock,
    Hide_NoStock,
}

export enum BOMAlertFrequencyType {
    None = 0,
    Daily = 1,
    Weekly = 2,
}

export enum DayOfWeek {
    Sunday,
    Monday,
    Tuesday,
    Wednesday,
    Thursday,
    Friday,
    Saturday,
}

export enum BOMAlertTypes {
    AvailabilityChange = 1,
    PurchaseQuantityMetChange = 2,
    LifecycleRiskChange = 3,
    SupplyChainRiskChange = 4,
}
